import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TUI_DARK_MODE } from '@taiga-ui/core';
import { StorageKeys } from '@src/constants/storage';
import { removeHackTheme } from '@src/hacks/theme';

import { StorageService } from '../../auth';
import { ThemeBrightnessEnum } from '../types';

@Injectable({
  providedIn: 'root',
})
export class ThemeSwitcherService {
  private readonly storageService = inject(StorageService);
  private readonly darkMode = inject(TUI_DARK_MODE);

  readonly isDark$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() {
    // HACK: удаляем тему при загрузке
    removeHackTheme();

    this.init();
  }

  init() {
    const isDark = this.storageService.getItem(StorageKeys.Theme) === ThemeBrightnessEnum.Dark;
    this.darkMode.set(isDark);
  }

  setTheme(isDark: boolean) {
    this.darkMode.set(isDark);
    this.storageService.setItem(StorageKeys.Theme, isDark ? ThemeBrightnessEnum.Dark : ThemeBrightnessEnum.Light);
  }

  getTheme() {
    return this.storageService.getItem(StorageKeys.Theme);
  }
}
